export default "__VITE_ASSET__BPlzxOVQ__"